import { render, staticRenderFns } from "./card-choose-list.vue?vue&type=template&id=65996af6&scoped=true&lang=pug&"
import script from "./card-choose-list.vue?vue&type=script&lang=js&"
export * from "./card-choose-list.vue?vue&type=script&lang=js&"
import style0 from "./card-choose-list.vue?vue&type=style&index=0&id=65996af6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65996af6",
  null
  
)

export default component.exports